import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box } from '@mui/material';
import { CameraAltRounded, PhotoLibrary } from '@mui/icons-material';

const ImageUploader = ({ handleCapture }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleCameraClick = () => {
        document.getElementById('camera-input').click();
        handleDialogClose();
    };

    const handleFileClick = () => {
        document.getElementById('file-input').click();
        handleDialogClose();
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center', // Center the button
                padding: '10px 0',
                width: '100%',
            }}
        >
            <Button variant="contained" color="primary" onClick={handleDialogOpen}>
                <CameraAltRounded /> Add Pictures
            </Button>

            {/* Hidden inputs for file and camera */}
            <input
                id="camera-input"
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={handleCapture}
                multiple // Enable multi-selection if supported
            />
            <input
                id="file-input"
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleCapture}
                multiple // Enable multi-selection for file input
            />

            {/* Dialog with camera or file upload options */}
            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogTitle>Select an Option</DialogTitle>
                <DialogContent>
                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<CameraAltRounded />}
                        onClick={handleCameraClick}
                        sx={{ marginBottom: '10px' }}
                    >
                        Use Camera
                    </Button>
                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<PhotoLibrary />}
                        onClick={handleFileClick}
                    >
                        Upload from Device
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ImageUploader;
